interface BoatIndicatorProps {
  boatNumber: number
  color: string
  size?: 'sm' | 'md' | 'lg'
}

export function BoatIndicator({ boatNumber, color, size = 'md' }: BoatIndicatorProps) {
  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-12 h-12 text-base',
    lg: 'w-16 h-16 text-2xl',
  }

  return (
    <div
      className={`
        ${sizeClasses[size]}
        flex items-center justify-center rounded-lg font-fredoka font-700
        text-white border-2 border-white
        transition-all duration-300 hover:scale-110
      `}
      style={{
        backgroundColor: color,
        boxShadow: `0 0 20px ${color}80, inset 0 0 10px ${color}40`,
      }}
    >
      {boatNumber}
    </div>
  )
}
